{ 
  filename = "__base__/graphics/entity/TODO\OUTPUT/boiler-E-patch.png",
  line_length = 1,
  width = 3,
  height = 17,
  frame_count = 1,
  axially_symmetrical = false,
  direction_count = 1,
  shift = util.by_pixel(33.5, -13.5)
}